import type { RouteObject } from "react-router";
import Patients from "./ui/pages/Patients";
import AddPatient from "./ui/pages/AddPatient";
import AddCouplePatient from "./ui/pages/AddCouplePatient";
import AddGroupPatient from "./ui/pages/AddGroupPatient";

/** The caseload and the forms that add to it. Each record's page is patient_record's. */
export const patientRoutes: RouteObject[] = [
    { path: "/patients", element: <Patients /> },
    { path: "/patients/new", element: <AddPatient /> },
    { path: "/couple-patient/new", element: <AddCouplePatient /> },
    { path: "/group-patient/new", element: <AddGroupPatient /> },
];
